import { render, staticRenderFns } from "./CheckboxSelect.vue?vue&type=template&id=f12f3140"
import script from "./CheckboxSelect.vue?vue&type=script&lang=js"
export * from "./CheckboxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f12f3140')) {
      api.createRecord('f12f3140', component.options)
    } else {
      api.reload('f12f3140', component.options)
    }
    module.hot.accept("./CheckboxSelect.vue?vue&type=template&id=f12f3140", function () {
      api.rerender('f12f3140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/helper/CheckboxSelect.vue"
export default component.exports